import { Briefcase, Code2, Gamepad2, Laptop, Palette, Rocket, Scale, Stethoscope, TrendingUp } from "lucide-react";

/** Maps the `icon` key in src/data/industries.js (and EXPLORE_PROGRAMS) to a lucide component. */
export const INDUSTRY_ICONS = {
  stethoscope: Stethoscope,
  code: Code2,
  palette: Palette,
  gamepad: Gamepad2,
  chart: TrendingUp,
  briefcase: Briefcase,
  scale: Scale,
  rocket: Rocket,
};

export function getIndustryIcon(key) {
  return INDUSTRY_ICONS[key] ?? Laptop;
}
